import {
    format, getUnixTime, startOfDay, endOfDay, subDays,
    startOfMonth, endOfMonth, subMonths,
} from "date-fns";

// created_at trong các bảng log là unix giây (INT) → format hiển thị.
export function fmtUnix(ts?: number): string {
    if (!ts) return "-";
    return format(new Date(ts * 1000), "dd/MM/yy HH:mm:ss");
}

// Khoảng lọc MẶC ĐỊNH khi mở tab: 7 ngày gần nhất.
// Không đặt mặc định thì mỗi lần mở tab là 4 truy vấn quét TOÀN BỘ bảng
// (list + count, stat card, biểu đồ, nhóm lỗi) trên bảng vài trăm nghìn dòng.
export function defaultRange(): { from: number; to: number } {
    const now = new Date();
    return {
        from: getUnixTime(startOfDay(subDays(now, 6))),
        to: getUnixTime(endOfDay(now)),
    };
}

// Khoảng thời gian nhanh cho thanh lọc (from/to là unix giây).
// Dùng mốc đầu/cuối ngày-tháng (ổn định trong ngày) → highlight nút đang chọn khớp.
export type QuickRange = { label: string; from: number; to: number };
export function quickRanges(): QuickRange[] {
    const now = new Date();
    const yesterday = subDays(now, 1);
    const lastMonth = subMonths(now, 1);
    const u = getUnixTime;
    return [
        { label: "Hôm nay", from: u(startOfDay(now)), to: u(endOfDay(now)) },
        { label: "Hôm qua", from: u(startOfDay(yesterday)), to: u(endOfDay(yesterday)) },
        { label: "7 ngày qua", from: u(startOfDay(subDays(now, 6))), to: u(endOfDay(now)) },
        { label: "30 ngày qua", from: u(startOfDay(subDays(now, 29))), to: u(endOfDay(now)) },
        { label: "Tháng này", from: u(startOfMonth(now)), to: u(endOfMonth(now)) },
        { label: "Tháng trước", from: u(startOfMonth(lastMonth)), to: u(endOfMonth(lastMonth)) },
    ];
}

// Xuất CSV nay do backend stream (GET /admin/logs/:type/export) để lấy được
// TOÀN BỘ kết quả lọc, không chỉ trang đang xem — xem log-api.exportCsv.
